import React from 'react';
import axios from 'axios';
import FontAwesome from 'react-fontawesome';
import {Button, Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";

import Table from "../../components/Table/index";

class NewsfeedList extends React.Component{
    constructor(props) {
        super(props);

        const tooltipPreview = (
            <Tooltip id="tooltip-preview">Náhled</Tooltip>
        );
        const tooltipEdit = (
            <Tooltip id="tooltip-edit">Upravit</Tooltip>
        );
        const tooltipRemove = (
            <Tooltip id="tooltip-remove">Odstranit</Tooltip>
        );
        const tooltipEnable = (
            <Tooltip id="tooltip-enable">Zakázat novinku</Tooltip>
        );
        const tooltipDisable = (
            <Tooltip id="tooltip-disable">Povolit novinku</Tooltip>
        );

        const columns = [{
            Header: 'Název',
            accessor: 'name',
        }, {
            Header: 'Možnosti',
            style: {padding: '0px'},
            filterable: false,
            Cell: row => (
                <div className="row-menu">
                    <OverlayTrigger placement="top" overlay={tooltipPreview}>
                        <Link to={`/newsfeeds/preview/${row.original.id}`}>
                            <FontAwesome
                              name="eye"
                              className="cursor-p"
                            />
                        </Link>
                    </OverlayTrigger>
                    {
                        row.original.enabled &&
                        <OverlayTrigger placement="top" overlay={tooltipEnable}>
                            <FontAwesome name="unlock" onClick={() => this.props.handleChangeEnabled(row.original)}
                                         className="cursor-p"/>
                        </OverlayTrigger>
                    }
                    {
                        !row.original.enabled &&
                        <OverlayTrigger placement="top" overlay={tooltipDisable}>
                            <FontAwesome name="lock" onClick={() => this.props.handleChangeEnabled(row.original)}
                                         className="cursor-p"/>
                        </OverlayTrigger>
                    }
                    <OverlayTrigger placement="top" overlay={tooltipEdit}>
                        <Link to={`/newsfeeds/edit/${row.original.id}`}>
                            <FontAwesome
                              name="pencil-square-o"
                              className="cursor-p"
                            />
                        </Link>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={tooltipRemove}>
                        <FontAwesome name="trash" onClick={() => this.showModal(row.original)}
                                     className="cursor-p"/>
                    </OverlayTrigger>
                </div>
            )
        }];

        const tableOptions = {
            showPagination: true,
            showPageSizeOptions: true,
            showPageJump: true,
            collapseOnSortingChange: true,
            collapseOnPageChange: true,
            collapseOnDataChange: true,
            freezeWhenExpanded: false,
            filterable: true,
            sortable: true,
            resizable: true,
            defaultPageSize: 10,
            defaultSorted: [{
                id: 'name',
                desc: false
            }]
        };

        this.state = {
            newsfeeds: [],
            removeNewsfeed: null,
            columns,
            tableOptions
        };

        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        this.getNewsfeeds();
    };

    getNewsfeeds() {
        this.setState({
            tableOptions: {
                ...this.state.tableOptions,
                loading: true
            }
        });
        axios.get(this.props.api.newsfeeds, {
            params: {
                all: true
            }
        }).then((response) => {
            if (!this._componentWillUnmount) {
                this.setState({
                    newsfeeds: response.data,
                    tableOptions: {
                        ...this.state.tableOptions,
                        loading: false
                    }
                });
            }
        }).catch((error) => {
            console.log("Axios error: ", error);
        });
    }

    closeModal() {
        this.setState({
            showModal: false,
            removeNewsfeed: null
        })
    }

    showModal(newsFeed) {
        this.setState({
            showModal: true,
            removeNewsfeed: newsFeed
        })
    }

    render() {
        const {newsfeeds, removeNewsfeed, columns, tableOptions} = this.state;
        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>Seznam novinek</h2>
                    <Button className="btn-success btn-add" onClick={() => this.props.history.push('/newsfeeds/add')}>
                        <FontAwesome name="plus"/>
                    </Button>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    <Table
                        columns={columns}
                        data={newsfeeds}
                        tableOptions={tableOptions}
                        defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
                        options={{}}
                    />
                </div>
                {
                    removeNewsfeed &&
                    <Modal show={this.state.showModal} onHide={this.closeModal} backdrop='static'>
                        <Modal.Header closeButton className="text-danger bg-danger">
                            <Modal.Title>Odstranění novinky</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Opravdu chcete odstranit novinku: {removeNewsfeed.name}?</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.closeModal}>Zrušit</Button>
                            <Button className='btn btn-danger' onClick={() => this.props.handleRemoveNewsfeed(removeNewsfeed)}>Odstranit</Button>
                        </Modal.Footer>
                    </Modal>
                }
            </div>
        );
    }
}

export default withRouter(NewsfeedList);



/** WEBPACK FOOTER **
 ** ./src/containers/Newsfeeds/NewsfeedList.js
 **/